<div class="kt-portlet">
    <div class="kt-portlet__head  d-flex align-items-center justify-content-between">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Yeni Etkinlik Rolü Ekle
            </h3>
        </div>
        <button type="button" routerLink="/event-property-list/{{eventProperty.eventId}}" class="btn btn-secondary mr-3">Geri Dön</button>
    </div>
    <div class="container" style="width: 90%">
        <form class="kt-form kt-form--label-left" [formGroup]="addEventPropertyForm" (ngSubmit)="save()" autocomplete="off">
            <div class="kt-portlet__body">
                <div class="form-group">
                    <label for="volunteerRoleTypeId" class="col-form-label">Rol</label>
                    <ng-select name="volunteerRoleTypeId" id="volunteerRoleTypeId" labelForId="volunteerRoleTypeId"
                        bindValue="id" style="width: 100%; float: left;clear: both;" placeholder="Etkinlik rolü" [items]="volunteerRoleTypes"
                        bindLabel="roleName" formControlName="volunteerRoleTypeId">
                    </ng-select>
                    <small class="form-text text-warning" *ngIf="f.volunteerRoleTypeId.errors?.required">Lütfen etkinlik rolü giriniz!</small>
                </div>

                <div class="form-group">
                    <label for="applicationEndDate" class="col-form-label">Son başvuru tarihi</label>
                    <input class="form-control" type="date" id="applicationEndDate"
                        formControlName="applicationEndDate" placeholder="Son başvuru tarihi" name="endDate">
                    <small class="form-text text-warning" *ngIf="f.applicationEndDate.errors?.required">Lütfen etkinlik son başvuru
                        tarihinizi giriniz!</small>
                </div>

                <div class="form-group">
                    <label class="col-form-label">Rol detay bilgisi</label>

                    <input formControlName="description" type="text" class="form-control"
                        placeholder="Rol detay bilgisi..">
                    <small class="form-text text-warning"
                        *ngIf="f.description.errors?.required">Lütfen rol detay bilgisi giriniz!</small>
                </div>

                <div class="form-group">
                    <label class="col-form-label">Kontenjan</label>

                    <input formControlName="maxApplication" type="number" class="form-control"
                        placeholder="Kontenjan..">
                    <small class="form-text text-warning"
                        *ngIf="f.maxApplication.errors?.required">Lütfen kontenjan giriniz!</small>
                    <small class="form-text text-warning"
                        *ngIf="f.maxApplication.errors?.min">Lütfen 0'dan büyük kontenjan giriniz!</small>
                </div>
            </div>
            <div class="kt-portlet__foot">
                <div class="kt-form__actions">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-success" (click)="save()">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>